import React from 'react';
import {
  AppBar,
  Box,
  createTheme,
  ThemeProvider,
  Toolbar,
} from '@mui/material';

const darkTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#e0e0e0',
    },
  },
});

export const SignNavigationBar = () => (
  <Box sx={{ flexGrow: 1 }}>
    <ThemeProvider theme={darkTheme}>
      <AppBar position="static">
        <Toolbar>
          <div> </div>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  </Box>
);
